import createDappAsyncThunk from "../asyncThunk"

// Generate bridge reveal data and btc address that needs to receive BTC to be
// bridged to Ethereum. It doesn't matter who will send the BTC to the address.
export const generateBitcoinDepositDetails = createDappAsyncThunk(
  "bitcoin/generateBitcoinDepositDetails",
  async (
    {
      bitcoinRecoveryAddress,
    }: {
      bitcoinRecoveryAddress: string
    },
    { extra: { sdk } },
  ) => {
    const initiatedDeposit =
      await sdk.mezo.chain?.tbtcModule.initiateBitcoinDeposit(
        bitcoinRecoveryAddress,
      )

    return initiatedDeposit ?? null
  },
)

// Calculates amount of BTC deposited to the deposit address
export const checkBitcoinDepositedAmount = createDappAsyncThunk(
  "bitcoin/checkBitcoinDepositStatus",
  async ({ address }: { address: string }, { extra: { sdk } }) => {
    const utxos =
      await sdk.mezo.chain?.tbtcModule.findAllUnspentTransactionOutputs(address)

    if (!utxos) {
      return 0n
    }

    return utxos.reduce((acc, utxo) => acc + (utxo.value?.toBigInt() ?? 0n), 0n)
  },
)
